<template>
  <div class="reg-ate-icone" v-if="statusGeral === ''">

    <!-- ICONE DO REGISTRO DE ATENDIMENTO -->
    <transition name="fade-reg-ate" v-if="$store.state.mobile === false">
      <div class="bola">
        <!-- SETA AS BOLINHAS -->
        <template v-for="(tp, indexL) in numeros">
          <span :key="'balao-' + indexL" v-if="tp.valor >= 1" @click="regAteIconeAbrirTimeLine(indexL)">
            <div v-html="tp.valor" :title="tp.title" class="balao" :class="'balao-' + indexL"></div>
          </span>
        </template>

        <!-- SETA O ICONE DA BOLA -->
        <div class="chat" @click="regAteIconeAbrirTimeLine()">
          <svg class="far fa-comment-dots"></svg>
        </div>
      </div>
    </transition>

    <!-- REGISTRO DE ATENDIMENTO -->
    <transition name="slide-fade-reg-ate">
      <Registro-Atendimento-Time-Line v-show="$store.state.atalhos['ALT+A'].mostrar === true" ref="reg_atendimento"></Registro-Atendimento-Time-Line>
    </transition>
  </div>
</template>

<style scoped>
  .reg-ate-icone > .bola {
    position: fixed;
    bottom: 5px;
    z-index: 2795;
    right: 10px;
    width: 45px;
    height: 45px;
    border-radius: 25px;
    text-align: center;
    background: #2687e9;
    color: #fff;
    cursor: pointer;
  }
    .reg-ate-icone > .bola > .chat {
      width: 40px;
      height: 40px;
      margin: 0px auto;
      padding: 10px 8px;
    }
      .reg-ate-icone > .bola > .chat > svg {
        font-size: 25px;
      }

  .reg-ate-icone > .bola > span > .balao {
    position: fixed;
    min-width: 22px;
    min-height: 22px;
    line-height: 22px;
    border-radius: 50%;
    font-weight: bold;
    font-size: 12px;
    text-align: center;
    padding: 0px 4px;
  }
    .reg-ate-icone > .bola > span > .balao-resp_atual {
      color: rgb(255, 255, 255);
      background: rgb(210, 38, 40);
      bottom: 35px;
      right: 45px;
    }
    .reg-ate-icone > .bola > span > .balao-resp_outros {
      color: rgb(255, 255, 255);
      background: rgb(210, 38, 40);
      bottom: 35px;
      right: 2px;
    }

  /* ANIMAÇÃO O BOTÃO DE NOTIFICAÇÕES */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .fade-reg-ate-enter-active, .fade-reg-ate-leave-active {
    transition: opacity .5s;
  }
  .fade-reg-ate-enter, .fade-reg-ate-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  /* ANIMAÇÃO PARA ABRIR E FECHAR A TIME LINE */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  @keyframes slideInRight {
    from {
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
      visibility: visible;
    }
    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }
  @-webkit-keyframes slideInRight {
    from {
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
      visibility: visible;
    }

    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes slideInLeft {
    from {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      visibility: visible;
    }
    to {
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
  }
  @-webkit-keyframes slideInLeft {
    from {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      visibility: visible;
    }

    to {
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
  }
  .slide-fade-reg-ate-enter-active {
    -webkit-animation-name: slideInRight;
    animation-name: slideInRight;
    animation-duration: 0.7s;
  }
  .slide-fade-reg-ate-leave-active {
    -webkit-animation-name: slideInLeft;
    animation-name: slideInLeft;
    animation-duration: 0.7s;
  }
</style>

<script>
export default {
  components: {
    'Registro-Atendimento-Time-Line': () => import('@/components/registro-atendimento/Registro-Atendimento-Time-Line.vue')
  },
  data: function () {
    return {
      time: '',
      statusGeral: 'carregando',
      numeros: {
        resp_atual: { valor: 0, title: 'Número de assuntos que estão pendentes e você é o responsável.' },
        resp_outros: { valor: 0, title: 'Número de assuntos que estão pendentes e você NÃO é o responsável.' }
      }
    }
  },
  mounted: function () {
    this.regAteIconeIniciar()
  },
  destroyed: function () {
    this.$store.state.WEB_SOCKET_OBSERVADOR('RegAtendimento', 'reg-ate-icone', null)
  },
  methods: {
    regAteIconeIniciar: function () {
      // SETA OS STATUS DA TELA
      this.regAteIconeSetarStatusGeral('carregando')

      // ADICIONA O OBSERVADOR
      this.$store.state.WEB_SOCKET_OBSERVADOR('RegAtendimento', 'reg-ate-icone', this.regAteIconeRecebeMensagem, 'usu')

      // CHAMA A FUNÇÃO PARA BUSCAR AS QUANTIDADES
      this.regAteIconeBuscarQtdeBolinhaTotais()

      // SETA OS STATUS DA TELA
      this.regAteIconeSetarStatusGeral('')
    },
    regAteIconeSetarStatusGeral: function (status) {
      if ([ '', 'carregando' ].indexOf(status) !== -1) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      } else {
        this.$store.commit('SET_APP_STATUS', status)
      }
    },
    regAteIconeRecebeMensagem: function (event) {
      // PEGA O VALOR RECEBIDO
      event = Object.values(event)[0]

      // VERIFICA SE DEVE NOTIFICAR
      if ([ '', null, undefined, '1', 1 ].indexOf(event.notificar) !== -1) {
        // REALIZA A NOTIFICAÇÃO NA AREA DE TRABALHO DO CLIENTE
        this.regAteIconeNotificar(event)

        // SOMA NA QUANTIDADE NÃO LIDA
        if (this.$store.state.usuario.id_usu !== event.last_user && event.status === '1') {
          this.numeros.nLidos.valor += 1
        }
      } else {
        this.regAteIconeBuscarQtdeBolinhaTotais()
      }
    },
    regAteIconeAbrirTimeLine: function (tipo = '') {
      // INICIA O VETOR
      var vetor = {}

      // VERIFICA SE É PARA FAZER ALGUMA BUSCA
      switch (tipo) {
        case 'resp_atual':
        case 'resp_outros':
          vetor.responsavel = JSON.parse(JSON.stringify(this.numeros[tipo].ids))
          vetor.status = []
          
          // PEGA TODOS OS STATUS EXISTENTES
          vetor._status = this.$refs.reg_atendimento.optionsSta.filter(item => item.notificar === 's')

          // PEGA O PRIMEIRO REGISTRO ENCONTRADO
          if (vetor._status.length >= 1) {
            vetor.status.push(vetor._status[0].id)
          }


          // REMOVE A CHAVE INFORMADA
          delete vetor._status
          break

        default:
          vetor.responsavel = []
          vetor.status = []
          break
      }
      // CHAMA A FUNÇÃO PARA ABRIR O REGISTRO DE ATENDIMENTO
      this.regAteIconeSetarFiltrosBuscar(vetor)
    },
    regAteIconeSetarFiltrosBuscar: function (vetor = {}) {
      if (Object.keys(vetor).length >= 1) {
        // CRIA AS CHAVES FALTANTES NO VETOR
        if ([ '', null, undefined ].indexOf(vetor.assuntoOr) !== -1) {
          vetor = Object.assign({ busca: '', responsavel: '', status: '', assuntoId: '' }, vetor)
        }
  
        // VERIFICA SE EXISTE OS CAMPOS DE FILTRO
        if ([ '', null, undefined ].indexOf(this.$refs.reg_atendimento) === -1 && Object.keys(this.$refs.reg_atendimento.filtros).length >= 1 && [ '', null, undefined ].indexOf(this.$refs.reg_atendimento.filtros.field) === -1) {
          for (var indexF in vetor) {
            switch (indexF) {
              case 'status':
              case 'responsavel':
                // INICIA A VARIAVEL
                if ([ '', null, undefined ].indexOf(vetor[indexF]) !== -1) {
                  vetor[indexF] = [ 't' ]
                } else if (typeof vetor[indexF] === 'string' || Array.isArray(vetor[indexF]) === false) {
                  vetor[indexF] = [ vetor[indexF] ]
                }

                // SETA O VALOR RECEBIDO NO CAMPO
                this.$refs.reg_atendimento.filtros.field[indexF].value = vetor[indexF]
                break
  
              case 'assuntoOr':
                this.$refs.reg_atendimento[indexF] = vetor[indexF]
                break

              case 'busca':
                this.$refs.reg_atendimento.filtroBusca = vetor[indexF].toString()
                break
            }
          }
  
          // SETA O TIME DA TELA
          this.$refs.reg_atendimento.time = new Date().getTime()
  
          // CHAMA A FUNÇÃO PARA PESQUISAR NOVAMENTE
          this.$refs.reg_atendimento.regAteTimeLineReiniciarTela(() => {
            // VERIFICA SE DEVE ALTERAR O ASSUNTO DA MENSAGEM
            if ([ '', null, undefined ].indexOf(vetor.assuntoId) === -1) {
              this.$refs.reg_atendimento.regAteTimeLineAlterarAssunto({ options: { reset: true }, room: { roomId: vetor.assuntoId } })
            }
          })
        }
      }

      // MANDA ABRIR O REGISTRO DE ATENDIMENTO
      if (this.$store.state.atalhos['ALT+A'].mostrar !== true) {
        this.$store.commit('EXECUTE_ATALHO', 'ALT+A')
      }
    },
    regAteIconeNotificar: function (event) {
      // VERIFICA SE É UMA CONEXÃO DO SUPORTE RF
      if ([ '', null, undefined ].indexOf(event.comentario) === -1 && event.comentario.indexOf('CONECTAR_SUPORTE_RF') !== -1) {
        // CONVERTE EM VETOR O VALOR RECEBIDO
        event.comentario = JSON.parse(event.comentario)

        // PEGA O MOTIVO DA CONEXÃO
        event.comentario = event.comentario.motivo

        // ALTERA O FLAG PARA NÃP NOTIFICAR, SE FOR UMA CONEXÃO COM O SUPORTE RF
        event.notificar = [ '', null, undefined ].indexOf(event.id_reg_ate_pai) !== -1 ? '0' : '1'
      }

      // PEGA A CHAVE QUE SERÁ UTILIZADA
      var responsavel = (([ '', null, undefined ].indexOf(event.responsavel_user) === -1) ? event.responsavel_user : event.ref_pai.responsavel_user)

      // VERIFICA SE DEVE NOTIFICAR
      if (this.$store.state.mobile === false && event.notificar === '1' && this.$store.state.usuario.id_usu !== event.last_user && this.$store.state.usuario.id_usu === responsavel && event.status === '1') {
        // PEGA A CHAVE QUE SERÁ UTILIZADA
        var chave = (([ '', null, undefined ].indexOf(event.id_reg_ate_pai) === -1) ? event.id_reg_ate_pai : event.id)

        // TRATAR CONCORRENCIA ABA
        const FUN_ADICIONAR_CONCORRENCIA_ABA = require('@/assets/js/Funcoes-Gerais.js').FUN_ADICIONAR_CONCORRENCIA_ABA

        // EXECUTA A FUNÇÃO PARA APRESENTAR APENAS UMA NOTIFICAÇÃO POR NAVEGADOR
        FUN_ADICIONAR_CONCORRENCIA_ABA('rgn', event.id, chave, () => {
          // IMPORTA BIBLIOTECA DEPENDENTE
          var moment = require('moment')

          // IMPORTA A FUNÇÃO
          const FUN_PEGAR_HORA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_HORA
          const FUN_NOTIFICATION = require('@/assets/js/Push-Notification.js').FUN_NOTIFICATION

          // PEGA OS DADOS DO USUARIO
          var usuario = this.$store.state.usuarios.filter(item => item.id === event.last_user)

          // VERIFICA SE FOI ENCONTRADO O USUARIO
          if (usuario.length >= 1) {
            // PEGA OS DADOS ENCONTRADOS
            usuario = usuario[0]

            // SETA OS DADOS DO USUARIO
            for (var indexU in usuario) {
              event['last_user_' + indexU] = usuario[indexU]
            }
          }
          
          // FORMATA A DATA RECEBIDA
          event.data_hora = moment(event.last_at, 'YYYY-MM-DD HH:mm:ss')

          // FORMATA A DATA RECEBIDA
          event.last_at_ptbr = event.data_hora.format('DD/MM/YYYY HH:mm:ss')
          event.last_at_ptbr = event.last_at_ptbr.split(' ').join(' às ')

          // SETA O TITULO QUE DEVE SER APRESENTADO
          var titulo = event.last_user_usuario

          // PEGA O NOME DO CONTATO
          if ([ '', null, undefined ].indexOf(event.id_contato_nome) === -1) {
            titulo += ' - ' + event.id_contato_nome
          } else if ([ '', null, undefined ].indexOf(event.ref_pai) === -1 && [ '', null, undefined ].indexOf(event.ref_pai.id_contato_nome) === -1) {
            titulo += ' - ' + event.ref_pai.id_contato_nome
          }

          // MONTA MENSAGEM QUE SERÁ MOSTRADA NA NOTIFICAÇÃO
          var menagem = [ '', null, undefined ].indexOf(event.comentario) === -1 ? event.comentario : ''

          // VERIFICA SE FOI RECEBIDO ALGUM ARQUIVO
          if ([ '', null, undefined ].indexOf(event.ws_arm_arquivo) === -1 && event.ws_arm_arquivo === '1') {
            menagem += [ '', null, undefined ].indexOf(menagem) === -1 ? ' - ' : ''
            menagem += 'Anexou um arquivo'
          }
          
          // ADICIONA A HORA DA MENSAGEM
          menagem += ' - ' + FUN_PEGAR_HORA(event.last_at_ptbr)

          // SETA O FORMULARIO QUE SERÁ ENVIADO
          var formData = {}

          // SETA O ID DO CONTATO QUE DEVE ABRIR
          formData.contato = ([ '', null, undefined ].indexOf(event.id_contato) === -1) ? event.id_contato : event.ref_pai.id_contato

          // SETA O ID DO ASSUNTO
          formData.assunto = ([ '', null, undefined ].indexOf(event.id_reg_ate_pai) === -1) ? event.id_reg_ate_pai : event.id

          // SETA O ID DO ASSUNTO
          formData.mensagem = event.id

          // FAZ A NOTIFICAÇÃO NO NAVEGADOR
          FUN_NOTIFICATION(titulo, menagem, formData, (data) => {
            // DA O FOCUS NA ABA SOLICITADA
            window.focus()

            // SETA O REGISTRO DE ATENDIMENTO
            this.$store.commit('SET_REG_ATENDIMENTO', data)
          })
        })
      }
    },
    regAteIconeBuscarQtdeBolinhaTotais: function () {
      if (this.$store.state.atalhos['ALT+A'].mostrar !== true) {
        this.regAteIconeBuscarQtdeBolinhasResponsavel()
      }
    },
    regAteIconeBuscarQtdeBolinhasResponsavel: function () {
      // INICIA O QUERYGET
      var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { responsavel_user: { o: 'count' }, id_status: { a: '_REMOVER_', j: { notificar: { a: '_REMOVER_' } } } }, group: [ 'responsavel_user' ] }

      // SETA O WHERE PARA PEGAR OS REGISTROS PAÍS
      queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_reg_ate_pai', o: 'isNull' }, { m: 'reg_ate_status', f: 'notificar', o: '=', v: 's' } ] }

      // FAZ A BUSCA NA API
      this.$store.state.comunicaAPI('/reg-atendimento/get/', 'GET', queryGet, (retorno) => {
        // LIMPA AS VARIAVEIS
        this.numeros.resp_atual.valor = 0
        this.numeros.resp_atual.ids = []
        this.numeros.resp_outros.valor = 0
        this.numeros.resp_outros.ids = []

        // RODA O VETOR PROCURANDO OS VALORES
        for (var indexI in retorno.data) {
          // INICIA O NOME DA CHAVE
          var chave = Number(retorno.data[indexI].responsavel_user) === this.$store.state.token.clu_iu ? 'resp_atual' : 'resp_outros'

          // SOMA A QUANTIDADE ENCONTRADA
          this.numeros[chave].valor += Number(retorno.data[indexI].responsavel_user_count)

          // ADICIONA OS IDS ENCONTRADOS
          this.numeros[chave].ids.push(retorno.data[indexI].responsavel_user.toString())
        }

        // REMOVE OS VALORES DUPLICADOS SE EXISTIR
        for (var indexT in this.numeros) {
          this.numeros[indexT].ids = this.numeros[indexT].ids.filter((v, i, a) => a.indexOf(v) === i)
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }, this.regAteIconeSetarStatusGeral)
    }
  },
  watch: {
    '$store.state.regatendimento': function () {
      if ([ '', null, undefined ].indexOf(this.$store.state.regatendimento) === -1) {
        // INICIA O VETOR QUE SERÁ COLOCADO NO FILTRO
        var vetor = {}

        // SETA O NUMERO DO ASSUNTO QUE DEVE ABRIR
        if ([ '', null, undefined ].indexOf(this.$store.state.regatendimento.assunto) === -1) {
          vetor.assuntoId = Number(this.$store.state.regatendimento.assunto)
          vetor.assuntoOr = [ vetor.assuntoId ]
        } else {
          // SETA O VALOR RECEBIDO
          if ([ '', null, undefined ].indexOf(this.$store.state.regatendimento.busca) === -1) {
            vetor.busca = this.$store.state.regatendimento.busca
          }
  
          // SETA O VALOR RECEBIDO
          if ([ '', null, undefined ].indexOf(this.$store.state.regatendimento.responsavel) === -1) {
            vetor.responsavel = this.$store.state.regatendimento.responsavel
          }
  
          // SETA O VALOR RECEBIDO
          if ([ '', null, undefined ].indexOf(this.$store.state.regatendimento.status) === -1) {
            vetor.status = this.$store.state.regatendimento.status
          }

          // SETA O NUMERO DO ASSUNTO QUE DEVE ABRIR
          if ([ '', null, undefined ].indexOf(vetor.busca) !== -1 && [ '', null, undefined ].indexOf(this.$store.state.regatendimento.contato) === -1) {
            vetor.busca = 'con:' + this.$store.state.regatendimento.contato
          }
        }

        // CHAMA A FUNÇÃO PARA BUSCAR OS DADOS NO REGISTRO DE ATENDIMENTO
        this.regAteIconeSetarFiltrosBuscar(vetor)

        // LIMPA O VALOR RECEBIDO
        this.$store.commit('SET_REG_ATENDIMENTO', null)
      }
    }
  }
}
</script>
